  import React, { useState  , useEffect} from "react";
  import { useTranslation } from "react-i18next";
  import {
    useFetchAvailablePaymentQuery,
    useFetchExtraSettingQuery,
    useFetchPackagesQuery,
    useSubscribePackageMutation,
  } from "../../../app/feature/API/Helpers";
  import { toast } from "react-toastify";
  import { Modal, ModalHeader, ModalBody, Button } from "reactstrap";

  const Pricing = () => {
    const { t , i18n} = useTranslation();
    const { data: PackageData } = useFetchPackagesQuery();
    const { data: availablePayment } = useFetchAvailablePaymentQuery();
    const [subscribePackage, { isLoading }] = useSubscribePackageMutation();
    const [loadingPackageId, setLoadingPackageId] = useState(null);
    const [selectedPackageId, setSelectedPackageId] = useState(null);
    const [modalOpen, setModalOpen] = useState(false);
    const [banqueMisrModalOpen, setBanqueMisrModalOpen] = useState(false);
    const [banqueMisrHtml, setBanqueMisrHtml] = useState("");
    const { data } = useFetchExtraSettingQuery();
    const [stripeModalOpen, setStripeModalOpen] = useState(false);
    const [stripe, setStripe] = useState(null);
    const [elements, setElements] = useState(null);
    const [card, setCard] = useState(null);

  const base_currency_symbol = data?.extra?.map((e)=>e?.base_currency_symbol)
  const base_currency_rate = data?.extra?.map((e)=>e?.base_currency_rate)

    const [loadingPaymentId, setLoadingPaymentId] = useState(null);

    const token = localStorage.getItem("token_Front_Mied");

    const toggleModal = () => setModalOpen(!modalOpen);
    const toggleStripeModal = () => setStripeModalOpen(!stripeModalOpen);


    const handleSubscribe = (packageId, subscribeStatus) => {
      if (subscribeStatus === 1) {
        const message = i18n.language === "en" ? "You already have an active subscription." : "لديك اشتراك نشط بالفعل.";
        toast.warning(message);
        return;
      }
      setSelectedPackageId(packageId);
      toggleModal();
    };
    


    
    const handlePaymentSelection = (gateway) => {
      if (!selectedPackageId) return;
      setLoadingPaymentId(gateway);
      setLoadingPackageId(selectedPackageId);
    
      subscribePackage({ id: selectedPackageId, gateway })
        .unwrap()
        .then((response) => {
          if (gateway === "banquemisr") {
            if (response?.html) {
              // // إنشاء Blob URL للـ HTML المستلم
              // const blob = new Blob([response.html], { type: "text/html" });
              // const url = URL.createObjectURL(blob);
    
              // setBanqueMisrHtml(url); // تخزين الـ blob URL
              // setBanqueMisrModalOpen(true);
                        // إنشاء `data:` URL يحتوي على HTML
          // const encodedHtml = encodeURIComponent(response.html);
          // const dataUrl = `data:text/html;charset=utf-8,${encodedHtml}`;

          // setBanqueMisrHtml(dataUrl);
          // setBanqueMisrModalOpen(true);

          setBanqueMisrHtml(response.html);
          setBanqueMisrModalOpen(true);
            } else {
              if (response?.payment_url) {
                window.open(response.payment_url, "_blank");
              } else {
                return;
              }
            }
          } else {
            if (response.payment_url) {
              window.open(response.payment_url, "_blank");
            } else {
              return;
            }
          }
          setLoadingPaymentId(null);
          setLoadingPackageId(null);
          toggleModal();
        })
        .catch((error) => {
          toast.error(error.data?.err || t("subscription_failed"));
          setLoadingPackageId(null);
          setLoadingPaymentId(null);
        });
    };
    

    return (
      <section
        className="pricing-wrapper section-padding pricing-bg"
        data-aos="fade-up"
        style={{ paddingTop: "80px" }}
      >
        <div className="container">
          <div className="row">
            <div className="col-xl-12">
              <div className="block-contents text-center">
                <div className="section-title">
                  <h5>{t("subscribe")}</h5>
                  <span>{t("smart_plans")}</span>
                  <h2>{t("choose_your_plan")}</h2>
                </div>
              </div>
            </div>
          </div>
          <div className="pricing-two">
            <div className="container">
              <div className="row">
                {PackageData?.map((pkg) => (
                  <div className="col-lg-4" key={pkg.id}>
                    <div className="pricing-two__single">
                      <div className="pricing-two__top">
                        <h3>{pkg.title}</h3>
                      </div>
                      <div className="pricing-two__bottom">
                        <DescriptionWithIcons description={pkg.description} />
                        <p>
                          <b>{base_currency_symbol}</b> {(pkg.price * base_currency_rate).toFixed(2)} <span>{t(pkg.duration)}</span>
                        </p>
                        <div className="text-center">
                          {token ? (
                            <button
                            onClick={() => handleSubscribe(pkg.id, pkg.subscribe_status)}
                              className="thm-btn pricing-one__btn pricing-two__btn"
                            >
                              {isLoading && loadingPackageId === pkg.id ? (
                                <>
                                  {t("loading")}
                                  <i className="fa fa-spinner fa-spin" />
                                </>
                              ) : (
                                <>
                                  {t("choose_plan")}
                                  <i className="fa fa-angle-double-right" />
                                </>
                              )}
                            </button>
                          ) : (
                            <a
                              href="#create_account"
                              className="thm-btn pricing-one__btn pricing-two__btn"
                              onClick={(e) => {
                                e.preventDefault();
                                const element = document.getElementById("create_account");
                                window.scrollTo({
                                  top: element.offsetTop - 20,
                                  behavior: "smooth",
                                });
                              }}
                            >
                              {t("choose_plan")}
                              <i className="fa fa-angle-double-right" />
                            </a>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        <Modal isOpen={modalOpen} toggle={toggleModal} centered>
          <ModalHeader toggle={toggleModal}>
            {t("choose_payment_method")}
          </ModalHeader>
          <ModalBody style={{display:"flex",gap:'7px'}}>
            {availablePayment?.length > 0 ? (
              availablePayment.map((payment) => (
                <Button
    key={payment.keyword}
    color="primary"
    className="w-100"
    style={{ height: "60px", borderRadius: "6px" }}
    onClick={() => handlePaymentSelection(payment.keyword)}
    disabled={loadingPaymentId === payment.keyword} 
  >
    {loadingPaymentId === payment.keyword ? (
      <>
        {t("processing")}
        <i className="fa fa-spinner fa-spin ml-2" />
      </>
    ) : (
      payment.name
    )}
  </Button>
              ))
            ) : (
              <p className="text-center">{t("No_Data")}</p>
            )}
          </ModalBody>
        </Modal>

        <Modal
          isOpen={banqueMisrModalOpen}
          toggle={() => setBanqueMisrModalOpen(false)}
          size="lg"
        >
          <ModalHeader toggle={() => setBanqueMisrModalOpen(false)}>
            {t("banque_misr_payment")}
          </ModalHeader>
          <ModalBody style={{ height: "80vh" }}>
          <iframe
            title="Banque Misr Payment"
            srcDoc={banqueMisrHtml}
            style={{ width: "100%", height: "100%", border: "none" }}
          />
          </ModalBody>
        </Modal>
        {/* <Modal isOpen={stripeModalOpen} toggle={() => setStripeModalOpen(false)} size="lg">
          <ModalHeader toggle={() => setStripeModalOpen(false)}>
            {t("stripe_payment")}
          </ModalHeader>
          <ModalBody>
          <label for="card-element">
          Credit or debit card
      </label>
      <div id="card-element">
      </div>
          </ModalBody>
          <script src="https://js.stripe.com/v3/"></script>
        </Modal> */}

  <Modal isOpen={stripeModalOpen} toggle={toggleStripeModal} centered>
          <ModalHeader toggle={toggleStripeModal}>{t("stripe_payment")}</ModalHeader>
          <ModalBody>
            <div id="card-element"></div>
          </ModalBody>
        </Modal>
      </section>
    );
  };

  export default Pricing;

  const DescriptionWithIcons = ({ description }) => {
    const parts = description.split(/<br\s*\/?>/i);
    const { i18n } = useTranslation();
    const isArabic = i18n.language === "ar";

    return (
      <ul
        className="list-unstyled pricing-two__list border-none"
        style={{
          marginRight: isArabic ? "50px" : "0px",
          marginLeft: !isArabic ? "50px" : "0px",
        }}
      >
        {parts.map(
          (part, index) =>
            part.trim() && (
              <li
                key={index}
                style={{ textWrap: "nowrap", textAlign: isArabic ? "start" : "start" }}
              >
                <i
                  className="far fa-check"
                  style={{
                    marginRight: !isArabic ? "6px" : "0px",
                    marginLeft: isArabic ? "6px" : "0px",
                  }}
                />
                <span
                  dangerouslySetInnerHTML={{ __html: part }}
                  style={{ display: "inline-block" }}
                />
              </li>
            )
        )}
      </ul>
    );
  };
